import crypto from 'crypto-js';

export function getGravatarUrl(email: string, size = 80): string {
  // Convert email to lowercase and trim whitespace
  const normalizedEmail = email.toLowerCase().trim();
  
  // Create MD5 hash of email
  const hash = crypto.MD5(normalizedEmail).toString();
  
  // Return Gravatar URL with size parameter
  return `https://www.gravatar.com/avatar/${hash}?s=${size}&d=mp`;
}

export function getEmailHash(email: string): string {
  return crypto.MD5(email.toLowerCase().trim()).toString();
}